import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeChecker } from '@attain-apps/type-guards'

// TODO: this does not need to be custom

export const TRANSFORMER = graphql.transformers.IN.nullable(
  graphql.transformers.IN.custom<
    ents.core.dms.data.query.Variable.Lookup,
    graphql.schema.VariableValueInput[]
  >(variablesLookup =>
    Object.entries(variablesLookup)
      .map(([variable, value]) =>
        // NOTE: Undefined values are currently ignored as GraphQL would throw
        // an error if included
        value !== undefined
          ? {
              value: JSON.stringify(value),
              variable,
            }
          : undefined,
      )
      .filter(TypeChecker.isNotNullish.raw),
  ),
)
